import $ from 'jquery';
import { getState } from '~src/state';
import { setSvgColor } from '../ui';

export const updateUndoRedoControls = () => {
  const currentPageIndex = getState('currentPageIndex');
  const currentHistoryIndex = getState(
    `currentHistoryIndex[${currentPageIndex}]`,
    0
  );
  const history = getState(`history[${currentPageIndex}]`, []);
  const totalChangesSinceLastSave = getState('totalChangesSinceLastSave', 0);

  if (
    history.length <= 0 ||
    currentHistoryIndex <= 0 ||
    totalChangesSinceLastSave <= 0
  ) {
    setSvgColor('#editor-menu-undo', '#ffffff');
    $('#editor-menu-undo').attr('disabled', 'disabled');
  } else {
    setSvgColor('#editor-menu-undo', '#ffffff');
    $('#editor-menu-undo').removeAttr('disabled');
  }

  if (
    (history.length > 0 && history.length - 1 <= currentHistoryIndex) ||
    totalChangesSinceLastSave <= 0
  ) {
    setSvgColor('#editor-menu-redo', '#ffffff');
    $('#editor-menu-redo').attr('disabled', 'disabled');
  } else {
    setSvgColor('#editor-menu-redo', '#ffffff');
    $('#editor-menu-redo').removeAttr('disabled');
  }

  // Keep ruler white as well
  try {
    setSvgColor('#editor-menu-ruler', '#ffffff');
  } catch (e) {
    console.error('Failed setting ruler icon color', e);
  }
};
